import { motion } from "framer-motion";
import { useEffect } from "react";

const framerSidebarBackground = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0, transition: { delay: 0.1 } },
  transition: { duration: 0.3 },
};

export function PopupModal({
  onClose,
  children,
  contentClassName = "",
  overlayClassName = "",
  exit = { opacity: 0, transition: { delay: 0.1 } },
  shouldStopPropagation = true,
}: {
  onClose?: () => void;
  children: React.ReactNode;
  contentClassName?: string;
  overlayClassName?: string;
  exit?: any;
  shouldStopPropagation?: boolean;
}) {
  const handleClose = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onClose && onClose();
  };

  const disableScroll = () => {
    document.body.style.overflow = "hidden";
  };

  const enableScroll = () => {
    document.body.style.overflow = "";
  };

  useEffect(() => {
    disableScroll();
    return () => enableScroll();
  }, []);

  return (
    <>
      <div className="fixed z-[99] top-0 left-0 right-0 bottom-0 h-[100dvh] flex flex-col justify-center">
        <motion.div
          className={`fixed z-[99] top-0 left-0 right-0 bottom-0 bg-black/40 h-[100dvh] ${overlayClassName}`}
          onClick={handleClose}
          {...{ ...framerSidebarBackground, exit }}
        />
        <motion.div
          className={`p-8 bg-surface-primary rounded-[10px] relative flex-col gap-6 flex z-[99] shadow-modal ${contentClassName}`}
          {...framerSidebarBackground}
          onClick={(e) => {
            // stopPropagation only — never preventDefault. Cancelling a click
            // here strips its DEFAULT ACTION, and a <label>'s default action is
            // forwarding the click to the control it labels: with
            // preventDefault, clicking the word beside a radio or a checkbox
            // did nothing at all, in every modal in the portal. (Found on
            // tracking-health's accept-as-condition modal, where "structural"
            // could not be selected.) Closing on an outside click is the
            // overlay's job — it is a sibling, so nothing in here reaches it.
            if (shouldStopPropagation) e.stopPropagation();
          }}
        >
          {children}
        </motion.div>
      </div>
    </>
  );
}
